import swal from "sweetalert";
import { BACKEND } from "../context/backend";

export function getTurnosService(authTokens) {

  return fetch(BACKEND+"/api/turnos/", {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
  }).then((data) => data.json());
}

export function createTurnosService(turnos, authTokens) {
  const body = JSON.stringify(turnos);

  return fetch(BACKEND+`/api/turnos/`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + String(authTokens.access),
    },
    body,
  }).then((response) => {
    if (response.status === 200) {
      swal("Cambios guardados!", {
        button: false,
        icon: "success",
        timer: "1500",
      });
      return response.json();
    } else {
      swal("Algo salio mal", {
        button: false,
        icon: "error",
        timer: "1500",
      });
    }
  });
}

